function EventContextObject({ object, canvas, canvasPoint, screenPoint, intersection }) {
    return function () {
        const evt = new Event("context-object");

        evt.object = object;
        evt.source = canvas;
        evt.canvasPoint = canvasPoint;
        evt.screenPoint = screenPoint;
        evt.intersection = intersection;

        return evt;
    }();
}

export default EventContextObject;
export { EventContextObject };